module.exports = require("traverse");


//////////////////
// WEBPACK FOOTER
// external "traverse"
// module id = 466
// module chunks = 0